//导出运单为excel
import { saveAs } from "file-saver";
import XLSX from "xlsx/dist/xlsx.full.min";

function datenum(v, date1904) {
  if (date1904) v += 1462;
  let epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function data2ws(data) {
  const ws = {
    s: {
      "!row": [
        {
          wpx: 60,
        },
      ],
    },
  };
  ws["!cols"] = [];
  if(!data[1]){
    data[1]=new Array()
  }
  for (var n = 0; n != data[1].length; ++n) {
    ws["!cols"].push({
      wpx: null,
    });
  }
  let len = [];
  // console.log(data)
  // for (let i = 0; i < data.length; i++) {
  //   for (let j = 0; j < data[i][j].length; j++) {
  //     console.log(data[i][j].length)
  //   }
  // }
  for (let i = 0; i < data[1].length; i++) {
    if (data[1][i] == null || data[1][i] == undefined) {
      ws["!cols"].push({
        wpx: 60,
      });
    } else {
      if (data[1][i].length !== undefined) {
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        if (reg.test(data[1][i])) {
          ws["!cols"][i].wpx = Number(data[1][i].length) * 13 + 20;
        } else {
          ws["!cols"][i].wpx = Number(data[1][i].length) * 7;
        }
      }
      // console.log(data[1][i].length)
    }
  }
  console.log(ws["!cols"]);
  const range = {
    s: {
      c: 10000000,
      r: 10000000,
    },
    e: {
      c: 0,
      r: 0,
    },
  };
  for (let R = 0; R != data.length; ++R) {
    for (let C = 0; C != data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      const cell = {
        v: data[R][C],
      };
      if (cell.v == null) continue;
      const cell_ref = XLSX.utils.encode_cell({
        c: C,
        r: R,
      });

      if (typeof cell.v === "number") cell.t = "n";
      else if (typeof cell.v === "boolean") cell.t = "b";
      else if (cell.v instanceof Date) {
        cell.t = "n";
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = "s";

      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws["!ref"] = XLSX.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

/*
 * th => 表头
 * data => 数据
 * fileName => 文件名
 * fileType => 文件类型
 * sheetName => sheet页名
 */
export default function toExcel({
  th,
  title,
  address,
  project,
  date,
  data,
  fileName,
  fileType,
  sheetName,
  time,
}) {
  if (title) {
    data.unshift(["", "", "", "", "", title]);
    data.splice(1, 0, th);
  } else {
    data.unshift(th);
  }
  if (date) {
    data.unshift(["", "", "", date]);
    // data.splice(2, 0, th);
  }
  if (address) {
    data.unshift(["", "", "", address]);
  }
  if (project) {
    data.unshift(["", "", "", project]);
    // data.splice(2, 0, th);
  }
  if (time) {
    data.push([time]);
  }
  const wb = new Workbook(),
    ws = data2ws(data);
  sheetName = sheetName || "sheet1";
  wb.SheetNames.push(sheetName);
  wb.Sheets[sheetName] = ws;
  fileType = fileType || "xlsx";
  var wbout = XLSX.write(wb, {
    bookType: fileType,
    bookSST: false,
    type: "binary",
  });
  fileName = fileName || "列表";
  saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    }),
    `${fileName}.${fileType}`
  );
}



// WEBPACK FOOTER //
// ./src/assets/js/file.js